import { render, staticRenderFns } from "./PEmailTagInput.vue?vue&type=template&id=fedd6514&scoped=true&"
import script from "./PEmailTagInput.vue?vue&type=script&lang=js&"
export * from "./PEmailTagInput.vue?vue&type=script&lang=js&"
import style0 from "./PEmailTagInput.vue?vue&type=style&index=0&id=fedd6514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedd6514",
  null
  
)

export default component.exports